module.exports = __webpack_public_path__ + "static/img/fail-img.13605252.png";